import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isDisabled", "wasChanged", "id", "value", "onChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import FormField from 'components/FormField';
import useUniqueId from 'hooks/useUniqueId';
import ScormAdvancedSettingsModal from 'screens/ScormAdvancedSettingsModal';
import Button from 'components/Button';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ScormSettingsField(_ref) {
  var isDisabled = _ref.isDisabled,
    wasChanged = _ref.wasChanged,
    id = _ref.id,
    value = _ref.value,
    onChange = _ref.onChange,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var uniqueId = useUniqueId(id);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showAdvancedSettingsModal = _useState2[0],
    setShowAdvancedSettingsModal = _useState2[1];
  return /*#__PURE__*/_jsxs(FormField, _objectSpread(_objectSpread({
    as: "span",
    label: t('form_scorm_settings'),
    labelId: uniqueId
  }, otherProps), {}, {
    children: [/*#__PURE__*/_jsx(Button, {
      isDisabled: isDisabled,
      size: "medium",
      variant: "transparent",
      onClick: function onClick() {
        return setShowAdvancedSettingsModal(true);
      },
      ml: "-xs",
      "aria-describedby": t('actions_edit_scorm_settings'),
      children: t('actions_edit')
    }), showAdvancedSettingsModal && /*#__PURE__*/_jsx(ScormAdvancedSettingsModal, {
      onChange: onChange,
      defaultSettings: value,
      onClose: function onClose() {
        return setShowAdvancedSettingsModal(false);
      },
      onSave: function onSave() {
        return setShowAdvancedSettingsModal(false);
      },
      isButtonDisabled: !wasChanged
    })]
  }));
}
export default ScormSettingsField;